import React from 'react';
import { Trash2 } from 'lucide-react';

export function DeleteConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onCancel}>
      <div data-testid="delete-confirm-modal" className="bg-[#171A21] rounded-2xl border border-white/10 p-6 w-full max-w-sm" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-500/10 mx-auto mb-4">
          <Trash2 size={22} className="text-red-400" />
        </div>
        <h3 className="text-white font-semibold text-lg text-center mb-2">Confirm Delete</h3>
        <p className="text-[#94A3B8] text-sm text-center mb-6">{message}</p>
        <div className="flex gap-2">
          <button data-testid="delete-cancel-btn" onClick={onCancel} className="flex-1 bg-white/5 text-white rounded-full py-2.5 hover:bg-white/10 text-sm">Cancel</button>
          <button data-testid="delete-confirm-btn" onClick={onConfirm} className="flex-1 bg-red-500 text-white font-semibold hover:bg-red-600 rounded-full py-2.5 text-sm">Delete</button>
        </div>
      </div>
    </div>
  );
}
